import { FormattedMessage } from 'react-intl'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { BaseRuleStatus } from 'features/BaseRules/components/Status'
import { BaseRuleRoutes } from 'features/BaseRules/components/Routes'
import { BaseRuleSegments } from 'features/BaseRules/components/Segments'
import { BaseRuleServices } from 'features/BaseRules/components/Services'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { canWrite } from 'features/Users/utils'
import { InventoryRuleActions } from './Actions'
import { ReactElement } from 'react'
import { useLogin } from 'features/Login/hooks'
import { GTInventoryRule } from 'gql/types.generated'

export const InventoryRulesList = ({ inventoryRules = [] }: { inventoryRules: GTInventoryRule[] }): ReactElement => {
  const login = useLogin()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {canWrite(FEATURES.INVENTORY_RULE, login.accessToken.policies) && <Th />}
            <Th>
              <FormattedMessage id="inventoryRules.list.name" defaultMessage="Name" />
            </Th>
            <Th>
              <FormattedMessage id="inventoryRules.list.status" defaultMessage="Status" />
            </Th>
            <Th>
              <FormattedMessage id="inventoryRules.list.routes.header" defaultMessage="Routes" />
            </Th>
            <Th>
              <FormattedMessage id="inventoryRules.list.segments.header" defaultMessage="Segments" />
            </Th>
            <Th>
              <FormattedMessage id="inventoryRules.list.services.header" defaultMessage="Services" />
            </Th>
            <Th>
              <FormattedMessage id="inventoryRules.list.trips" defaultMessage="Trips" />
            </Th>
            <Th>
              <FormattedMessage id="inventoryRules.list.description" defaultMessage="Description" />
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {inventoryRules.map((inventoryRule): ReactElement => {
            return (
              <Tr key={inventoryRule.id}>
                {canWrite(FEATURES.INVENTORY_RULE, login.accessToken.policies) && (
                  <Td>
                    <InventoryRuleActions inventoryRule={inventoryRule} />
                  </Td>
                )}
                <Td>{inventoryRule.name}</Td>
                <Td>
                  <BaseRuleStatus status={inventoryRule.status} />
                </Td>
                <Td>
                  <BaseRuleRoutes baseRule={inventoryRule} />
                </Td>
                <Td>
                  <BaseRuleSegments baseRule={inventoryRule} />
                </Td>
                <Td>
                  <BaseRuleServices baseRule={inventoryRule} />
                </Td>
                <Td>{inventoryRule.tripsAffected}</Td>
                <Td>{inventoryRule.description}</Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
